import { PARTNER_LIFECYCLE_KEYS } from './partnerModel';

const blank = (value) => String(value ?? '').trim() === '';
const digits = (value) => String(value ?? '').replace(/\s/g, '');
const result = (fieldErrors, formError = null) => ({
  isValid: Object.keys(fieldErrors).length === 0 && !formError,
  fieldErrors,
  formError,
});

export const normalizePhone = (value) => String(value ?? '')
  .trim()
  .replace(/[\s().-]/g, '');

export const isValidPhone = (value) => {
  if (blank(value)) return true;
  const phone = normalizePhone(value);
  const digitCount = phone.replace(/\D/g, '').length;
  return /^\+?\d+$/.test(phone) && digitCount >= 10 && digitCount <= 15;
};

export const isValidEmail = (value) => (
  blank(value) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())
);

export const isValidSiren = (value) => blank(value) || /^\d{9}$/.test(digits(value));
export const isValidSiret = (value) => blank(value) || /^\d{14}$/.test(digits(value));
export const isValidVatNumber = (value) => (
  blank(value) || /^[A-Z]{2}[A-Z0-9]{2,12}$/.test(String(value).replace(/\s/g, '').toUpperCase())
);

export const validateLifecycleStatus = (value) => {
  if (blank(value)) return 'Le cycle de vie est obligatoire.';
  return PARTNER_LIFECYCLE_KEYS.has(value) ? null : 'Statut administratif invalide.';
};

const validateCommonContactFields = (data, fieldErrors) => {
  if (!isValidEmail(data.email)) fieldErrors.email = 'L’adresse email est invalide.';
  if (!isValidPhone(data.phone)) fieldErrors.phone = 'Le numéro de téléphone est invalide.';
  if (!isValidPhone(data.mobilePhone)) fieldErrors.mobilePhone = 'Le numéro de mobile est invalide.';
};

export const validatePartner = (partner = {}) => {
  const fieldErrors = {};
  if (blank(partner.socialReason) && blank(partner.name)) {
    fieldErrors.socialReason = 'La raison sociale ou le nom commercial est obligatoire.';
  }

  const lifecycleError = validateLifecycleStatus(partner.lifecycleStatus);
  if (lifecycleError) fieldErrors.lifecycleStatus = lifecycleError;

  if (!isValidSiren(partner.siren)) fieldErrors.siren = 'Le SIREN doit contenir 9 chiffres.';
  if (!isValidSiret(partner.siret)) fieldErrors.siret = 'Le SIRET doit contenir 14 chiffres.';
  if (!isValidVatNumber(partner.vat)) fieldErrors.vat = 'Le numéro de TVA est invalide.';
  if (!isValidEmail(partner.email)) fieldErrors.email = 'L’adresse email est invalide.';
  if (!isValidPhone(partner.phone)) fieldErrors.phone = 'Le numéro de téléphone est invalide.';
  if (!/^[A-Z]{2}$/.test(String(partner.countryCode || ''))) {
    fieldErrors.countryCode = 'Le code pays doit contenir deux lettres majuscules.';
  }

  ['employees', 'capital'].forEach((field) => {
    if (blank(partner[field])) return;
    const value = Number(partner[field]);
    if (Number.isFinite(value) && value < 0) {
      fieldErrors[field] = field === 'employees'
        ? 'L’effectif doit être positif.'
        : 'Le capital doit être positif.';
    }
  });

  return result(fieldErrors);
};

export const validatePartnerContact = (contact = {}) => {
  const fieldErrors = {};
  if (blank(contact.firstName) && blank(contact.lastName) && blank(contact.contactName)) {
    fieldErrors.contactName = 'Le nom du contact est obligatoire.';
  }
  validateCommonContactFields(contact, fieldErrors);
  return result(fieldErrors);
};

export const validatePartnerAgency = (agency = {}) => {
  const fieldErrors = {};
  if (blank(agency.socialReason) && blank(agency.name)) {
    fieldErrors.socialReason = 'La raison sociale ou le nom de l’agence est obligatoire.';
  }
  validateCommonContactFields(agency, fieldErrors);
  if (!/^[A-Z]{2}$/.test(String(agency.countryCode || ''))) {
    fieldErrors.countryCode = 'Le code pays doit contenir deux lettres majuscules.';
  }
  return result(fieldErrors);
};
